var map = {
	"./account-choose-icon-dark.svg": "1f7c",
	"./account-choose-icon.svg": "f60a",
	"./account-icon-active.svg": "53b0",
	"./account-icon-dark.svg": "e5e9",
	"./account-icon.svg": "a95c",
	"./developers-icon-active.svg": "4302",
	"./developers-icon-dark.svg": "6ab0",
	"./developers-icon.svg": "c9c2",
	"./members-icon-active.svg": "c7ac",
	"./members-icon-dark.svg": "d42d",
	"./members-icon.svg": "894d",
	"./notification-icon-active.svg": "17a3",
	"./notification-icon-dark.svg": "66d8",
	"./notification-icon.svg": "fcb5",
	"./pos-icon-active.svg": "03c6",
	"./pos-icon-dark.svg": "b9f9",
	"./pos-icon.svg": "ceae",
	"./sii-icon-active.svg": "47d4",
	"./sii-icon-dark.svg": "b2e8",
	"./sii-icon.svg": "311c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c5ba";